import React, { useState, useEffect, useRef } from 'react';
import { seoServices } from '../../../services/seoAPIServices'; 
import { Input } from '../../ui/input';
import { Loader2, Layers } from 'lucide-react';

const GroupSearch = ({ onSelect, countryCode, placeholder = "Select Group...", purpose = null, initialName = '' }) => {
  const [query, setQuery] = useState(initialName);
  const [allGroups, setAllGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showResults, setShowResults] = useState(false);
  
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowResults(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Use Effect to load groups, re-run if PURPOSE changes
  useEffect(() => {
    if (!countryCode) return;

    const loadAllGroups = async () => {
      setLoading(true);
      try {
        // Pass purpose to service
        const data = await seoServices.searchGroups("", countryCode, purpose);
        setAllGroups(data || []);
      } catch (error) {
        console.error("Failed to load category groups", error);
      } finally {
        setLoading(false);
      }
    };

    loadAllGroups();
  }, [countryCode, purpose]);

  const filteredResults = allGroups.filter(g => 
      g.name.toLowerCase().includes(query.toLowerCase()) || 
      g.slug.toLowerCase().includes(query.toLowerCase())
  );

  const handleSelect = (group) => {
    setQuery(group.name);
    setShowResults(false);
    onSelect(group);
  };

  return (
    <div className="relative w-full" ref={wrapperRef}>
      <div className="relative">
        <Input 
          value={query}
          onChange={(e) => { setQuery(e.target.value); setShowResults(true); }}
          onFocus={() => setShowResults(true)} 
          placeholder={placeholder}
          className="pl-9 h-9 text-sm"
        />
        <Layers className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" />
        {loading && allGroups.length === 0 && (
            <Loader2 className="absolute right-3 top-2.5 h-4 w-4 animate-spin text-gray-400" />
        )}
      </div>

      {showResults && (
        <ul className="absolute z-50 w-full bg-white border rounded-md shadow-lg mt-1 max-h-60 overflow-auto">
          {filteredResults.length > 0 ? (
            filteredResults.map((group) => (
              <li 
                key={group.id}
                onClick={() => handleSelect(group)}
                className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm border-b last:border-none"
              >
                <span className="font-medium text-gray-800">{group.name}</span>
                <span className="ml-2 text-xs text-gray-400 font-mono">{group.slug}</span>
              </li>
            ))
          ) : (
             <li className="p-3 text-xs text-gray-500 text-center">
                 {loading ? "Loading..." : "No groups found."}
             </li>
          )}
        </ul>
      )}
    </div>
  );
};

export default GroupSearch;